import { Schema } from "effect";
const LanguageISO6391Step1Schema = Schema.String.pipe(Schema.brand("@open-revenue/schema/Language/ISO6391/Step1"), Schema.annotations({
    description: "ISO 639-1 language code, step 1."
}));
const LanguageISO6391AnyStepSchema = Schema.String.pipe(Schema.brand("@open-revenue/schema/Language/ISO6391/AnyStep"), Schema.annotations({
    description: "ISO 639-1 language code, any step. Usually step 2."
}));
// const ISO 15924
const LanguageScriptISO15924Schema = Schema.String.pipe(Schema.brand("@open-revenue/schema/Language/Script/ISO15924"), Schema.annotations({
    description: "ISO 15924 language script code."
}));
export const Language = {
    ISO6391: {
        AnyStep: {
            Schema: LanguageISO6391AnyStepSchema,
            Type: LanguageISO6391AnyStepSchema.Type,
            make: (value)=>Schema.decode(LanguageISO6391AnyStepSchema)(value),
            makeUnsafe: (value)=>value
        },
        Step1: {
            en: "en",
            Schema: LanguageISO6391Step1Schema,
            Type: LanguageISO6391Step1Schema.Type,
            make: (value)=>Schema.decode(LanguageISO6391Step1Schema)(value),
            makeUnsafe: (value)=>value
        }
    },
    Script: {
        ISO15924: {
            Schema: LanguageScriptISO15924Schema,
            Type: LanguageScriptISO15924Schema.Type,
            make: (value)=>Schema.decode(LanguageScriptISO15924Schema)(value),
            makeUnsafe: (value)=>value
        }
    }
};
